import { useState, useEffect } from 'react';

import { breakpoints } from 'styles/theme/breakpoints';
import { useIsMounted } from './useIsMounted';

export function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  const [screenOrientation, setScreenOrientation] = useState('portrait');
  const isMounted = useIsMounted();

  useEffect(() => {
    function handleResize() {
      if (isMounted()) {
        setWindowSize({
          width: document.documentElement.clientWidth || window.innerWidth,
          height: document.documentElement.clientHeight || window.innerHeight,
        });
        const orientation = window.innerHeight / window.innerWidth > 1 ? 'portait' : 'landscape';
        setScreenOrientation(orientation);
      }
    }
    handleResize();

    // only execute all the code below in client side
    if (typeof window !== 'undefined') {
      // Add event listener
      window.addEventListener('resize', handleResize);
    }
    // Remove event listener on cleanup
    return () => {
      void window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isDesktop = windowSize.width >= breakpoints.mediumLarge;
  const isMobile = windowSize.width < breakpoints.mediumSmall;
  const isTablet =
    breakpoints.mediumSmall <= windowSize.width && windowSize.width < breakpoints.mediumLarge;

  const isMobileOrTablet = isMobile || isTablet;

  return {
    isDesktop,
    isMobile,
    isMobileOrTablet,
    isTablet,
    screenOrientation,
    windowSize,
  };
}
